import React, { useRef, useState } from 'react';
import { FaUpload } from 'react-icons/fa';
import css from './FileUploadButton.module.css';
import { useContext } from 'react';
import { UserContext } from '../../../context/userContext';
import ErrorModal from '../../Common/ErrorModal/ErrorModal';

interface FileUploadButtonProps {
  currentPath: string;
  onUploadComplete: () => void;
}

const FileUploadButton: React.FC<FileUploadButtonProps> = ({ 
  currentPath,
  onUploadComplete
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { user } = useContext(UserContext);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    try {
      console.log('Starting file upload...');
      console.log('Original current path:', currentPath);

      const formData = new FormData();
      Array.from(files).forEach(file => {
        formData.append('files', file);
        console.log('File to upload:', file.name);
      });

      // First replace %2F with REPLACINGSLASHES to preserve them
      const pathWithPreservedSlashes = currentPath.replace(/%2F/g, 'REPLACINGSLASHES');
      console.log('Path after preserving slashes:', pathWithPreservedSlashes);
      
      // Decode the path to work with it
      const decodedPath = decodeURIComponent(pathWithPreservedSlashes);
      console.log('Path after decoding:', decodedPath);
      
      // Convert back to %252F for API
      const apiPath = decodedPath.replace(/REPLACINGSLASHES/g, '%252F');
      console.log('Final API path:', apiPath);

      const url = `${process.env.REACT_APP_API_URL}/Documents?folderPath=${apiPath}`;
      console.log('Full upload URL:', url);

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${user?.accessToken}`,
        },
        body: formData,
      });

      console.log('Response status:', response.status);
      console.log('Response status text:', response.statusText);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Failed to upload files: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Upload successful. Result:', result);
      onUploadComplete();
    } catch (error) {
      console.error('Detailed upload error:', error);
      if (error instanceof Error) {
        console.error('Error stack:', error.stack);
        setErrorMessage(error.message);
      } else {
        setErrorMessage('Failed to upload files. Please try again.');
      }
      setShowErrorModal(true);
    }
  };

  return (
    <>
      {showErrorModal && (
        <ErrorModal
          title="Upload Error"
          message={errorMessage}
          onClose={() => setShowErrorModal(false)}
        />
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleUpload}
        multiple
        style={{ display: 'none' }}
      />
      <button
        className={css.uploadButton}
        onClick={() => fileInputRef.current?.click()}
      >
        <FaUpload className={css.uploadIcon} />
        Upload Files
      </button>
    </>
  );
};

export default FileUploadButton; 